<template>
    <div class="billingContainer">
        <div class="header">
            <div class="heading">
                <p class="title">Billing</p>
            </div>
        </div>
        <div class="paymentContainer">
           

            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="sub-heading">Upload Details</div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="buttons"> 

                <!-- ///// -->
                <div class="upload-section">
                    <div :class="[isCreditUploadFail ? 'upload-error-container': 'upload-container',{ 'drag-active': isCreditDragActive }]" @dragover.prevent="handleDragOver('credit')" @dragleave.prevent="handleDragLeave('credit')" @drop.prevent="handleDrop($event, 'credit')" >
                        <input type="file" id="uploadCreditDetails" name="uploadCreditDetails" @change="onUploadCreditDetailsBtnClick" class="file-input" accept=".csv"/>
                        <div class="upload-content">
                            <img src="../assets/uploadIcon.svg" alt="upload" class="upload-icon"/>
                            <div class="upload-text">
                                <label for="uploadCreditDetails" class="click-text"  @click="onInputClick">Click to upload</label>or drag and drop
                                <div class="file-types">.csv (max. 25mb)</div>
                            </div>
                            <div v-if="creditDetailsFile" :class="isCreditUploadFail ? 'file-error-info': 'file-info'">
                                <span class="file-name" :style="{color: isCreditUploadFail? '#be2e2e': '#0c0d38'}">{{ creditDetailsFile.name }}</span>
                                <span class="file-size">{{ formatFileSize(creditDetailsFile.size) }}</span>
                                <button class="remove-btn" @click="creditDetailsFile = null; isCreditUploadFail = false">×</button>
                            </div>
                            <div v-if="apiErrorMessage && isCreditUploadFail" class="errorHeading">
                                {{ apiErrorMessage }}
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="button-section">
                        <!-- <button class="upload-button" >Download Sample</button> -->
                        <button class="upload-button" :disabled="creditDetailsFile?false:true" :style="{opacity: creditDetailsFile ? 1 : 0.6 }" @click="onUploadCreditClick">Upload Credit Details</button>
                    </div>
                   
                </div>
                <!-- //// -->

                <div class="upload-section">
                    <div :class="[isPaymentUploadFail ? 'upload-error-container': 'upload-container',{ 'drag-active': isPaymentDragActive }]" @dragover.prevent="handleDragOver('payment')" @dragleave.prevent="handleDragLeave('payment')" @drop.prevent="handleDrop($event, 'payment')">
                        <input type="file" id="uploadRechargeDetails" name="uploadRechargeDetails" @change="onUploadRechargeDetailsBtnClick" class="file-input" accept=".csv"/>
                        <div class="upload-content">
                            <img src="../assets/uploadIcon.svg" alt="upload" class="upload-icon"/>
                            <div class="upload-text">
                                <label for="uploadRechargeDetails" class="click-text" @click="onInputClick">Click to upload</label>or drag and drop
                                <div class="file-types">.csv (max. 25mb)</div>
                            </div>
                            <div v-if="rechargeDetailsFile" :class="isPaymentUploadFail ? 'file-error-info': 'file-info'">
                                <span class="file-name" :style="{color: isPaymentUploadFail? '#be2e2e': '#0c0d38'}">{{ rechargeDetailsFile.name }}</span>
                                <span class="file-size">{{ formatFileSize(rechargeDetailsFile.size) }}</span>
                                <button class="remove-btn" @click="rechargeDetailsFile = null; isPaymentUploadFail = false">×</button>
                            </div>
                            <div v-if="apiErrorMessage && isPaymentUploadFail" class="errorHeading">
                                {{ apiErrorMessage }}
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="button-section">
                        <!-- <button class="upload-button" >Download Sample</button> -->
                        <button class="upload-button" :disabled="rechargeDetailsFile?false:true" :style="{opacity: rechargeDetailsFile ? 1 : 0.6 }" @click="onUploadRechargeClick">Upload Payment Details</button>
                    </div>
                   
                </div>

                <!-- //// -->

                <div class="upload-section">
                    <div :class="[isPromotionUploadFail ? 'upload-error-container': 'upload-container',{ 'drag-active': isPromotionalDragActive }]" @dragover.prevent="handleDragOver('promotion')" @dragleave.prevent="handleDragLeave('promotion')" @drop.prevent="handleDrop($event, 'promotion')" >
                        <input type="file" id="uploadPromotionalCredit" name="uploadPromotionalCredit" @change="onUploadPromotionalCreditBtnClick" class="file-input" accept=".csv"/>
                        <div class="upload-content">
                            <img src="../assets/uploadIcon.svg" alt="upload" class="upload-icon"/>
                            <div class="upload-text">
                                <label for="uploadPromotionalCredit" class="click-text" @click="onInputClick">Click to upload</label>or drag and drop
                                <div class="file-types">.csv (max. 25mb)</div>
                            </div>
                            <div v-if="promotionalCreditFile" class="file-info">
                                <span class="file-name" :style="{color: isPromotionUploadFail? '#be2e2e': '#0c0d38'}">{{ promotionalCreditFile.name }}</span>
                                <span class="file-size">{{ formatFileSize(promotionalCreditFile.size) }}</span>
                                <button class="remove-btn" @click="promotionalCreditFile = null; isPromotionUploadFail = false">×</button>
                            </div>
                            <div v-if="apiErrorMessage && isPromotionUploadFail" class="errorHeading">
                                {{ apiErrorMessage }}
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="button-section">
                        <!-- <button class="upload-button" >Download Sample</button> -->
                        <button class="upload-button" :disabled="promotionalCreditFile? false : true" :style="{opacity: promotionalCreditFile ? 1 : 0.6 }" @click="onUploadPromotionalCreditClick">Upload Promotional Credits</button>
                    </div>
                   
                </div>

                <!-- //// -->
            </div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="sub-heading">Download Reports</div>
            <div v-if="this.role === 'OPS' || this.role === 'SUPERADMIN'" class="buttons"> 
            
                <div class="btnWrap" style="margin-bottom: unset"> 
                    <img src="../assets/sampleCsv.svg" alt="download" class="csv-icon" />
                    <label for="uploadPromotionalCredit" style="max-width: unset">Generate Credit limits report</label>
                    <img src="../assets/download.svg" alt="download" class="download-icon" @click="onDownloadCreditsLimit" />
                </div>
                <div class="btnWrap" style="margin-bottom: unset"> 
                    <img src="../assets/sampleCsv.svg" alt="download" class="csv-icon" />
                    <label for="uploadPromotionalCredit" style="max-width: unset">Generate Promotional Credits report</label>
                    <img src="../assets/download.svg" alt="download" class="download-icon" @click="onDownloadPromotionalCredit" />
                </div>
                <div class="btnWrap" style="margin-bottom: unset"> 
                    <img src="../assets/sampleCsv.svg" alt="download" class="csv-icon" />
                    <label for="uploadPromotionalCredit" style="max-width: unset">Generate Overall Credit Summary report</label>
                    <img src="../assets/download.svg" alt="download" class="download-icon" @click="onDownloadOverallCredit" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { uploadCreditDetails, uploadRechargeDetails, uploadPromotionalCredit,
    getCookie, downloadCreditReport, downloadPromotionalCreditReport, downloadOverallCreditReport } from '../services/campaignService'

export default {
    name: 'Billing',
   data(){
    return{
        creditDetailsFile: null,
        rechargeDetailsFile: null,
        apiErrorMessage: null,
        apiSuccessMessage: null,
        promotionalCreditFile: null,
        role: '',
        isCreditDragActive: false,
        isPaymentDragActive: false,
        isPromotionalDragActive: false,
        isCreditUploadFail: false,
        isPaymentUploadFail: false,
        isPromotionUploadFail: false,
    }
   },
    mounted() {
        this.role = getCookie('role');
    },
   methods: {
        handleDragOver(type) {
            this.setDragState(type, true);
        },
        handleDragLeave(type) {
            this.setDragState(type, false);
        },
        handleDrop(event, type) {
            this.setDragState(type, false);
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.handleFileInput(files[0], type);
            }
        },
        setDragState(type, state) {
            switch (type) {
                case 'credit':
                this.isCreditDragActive = state;
                break;
                case 'payment':
                this.isPaymentDragActive = state;
                break;
                case 'promotion':
                this.isPromotionalDragActive = state;
                break;
            }
        },
        handleFileInput(file, type) {
            if (file.size > 25 * 1024 * 1024) {
                this.apiErrorMessage = 'File size exceeds 25MB limit';
                return;
            }
            switch(type) {
                case 'credit':
                    this.creditDetailsFile = file;
                    break;
                case 'payment':
                    this.rechargeDetailsFile = file;
                    break;
                case 'promotion':
                    this.promotionalCreditFile = file;
                    break;
            }
        },
        formatFileSize(bytes) {
           
        },
        onDownloadCreditsLimit(){
            downloadCreditReport();
        },
        onDownloadPromotionalCredit(){
            downloadPromotionalCreditReport();
        },
        onDownloadOverallCredit(){
            downloadOverallCreditReport();
        },
        onInputClick(){
            this.apiErrorMessage = null;
            this.apiSuccessMessage = null;
        },
        onUploadPromotionalCreditClick(){
            if(this.promotionalCreditFile){
                const formData = new FormData();
                formData.append('file', this.promotionalCreditFile);
                uploadPromotionalCredit(formData)
                .then(res=>{
                    if(res?.status === 400){
                        this.apiErrorMessage = 'Invalid file ! Please upload a valid file.';
                        this.isPromotionUploadFail = true;
                    }else if(res?.status === 200 || res?.status === 201){
                        const ele = document.getElementsByName('uploadPromotionalCredit')[0];
                        ele.value = ""
                        this.promotionalCreditFile = null;
                        this.apiErrorMessage = null;
                        this.apiSuccessMessage = 'Promo Credit Details Saved Successfully !'
                        return res.json()
                    } else {
                        this.apiErrorMessage = 'Server error.'
                        this.isPromotionUploadFail = true;
                    }
                })
            }
        },
        onUploadCreditClick(){
            if(this.creditDetailsFile){
                const formData = new FormData();
                formData.append('file', this.creditDetailsFile);
                uploadCreditDetails(formData)
                .then(res=>{
                    if(res?.status === 400){
                        this.apiErrorMessage = 'Invalid file ! Please upload a valid file.';
                        this.isCreditUploadFail = true;
                    }else if(res?.status === 200 || res?.status === 201){
                        const ele = document.getElementsByName('uploadCreditDetails')[0];
                        ele.value = ""
                        this.creditDetailsFile = null;
                        this.apiErrorMessage = null;
                        this.apiSuccessMessage = 'Credit Limit successfully uploaded !';
                        return res.json()
                    } else {
                        this.apiErrorMessage = 'Server error.';
                        this.isCreditUploadFail = true;
                    }
                })
            }
        },
        onUploadRechargeClick(){
            if(this.rechargeDetailsFile){
                const formData = new FormData();
                formData.append('file', this.rechargeDetailsFile);
                uploadRechargeDetails(formData)
                .then(res=>{
                    if(res?.status === 400){
                        this.apiErrorMessage = 'Invalid file ! Please upload a valid file.'
                        this.isPaymentUploadFail = true;
                    }else if(res?.status === 200 || res?.status === 201){
                        const ele = document.getElementsByName('uploadRechargeDetails')[0];
                        ele.value = ""
                        this.rechargeDetailsFile = null;
                        return res.json()
                    }else {
                        this.apiErrorMessage = 'Server error.';
                        this.isPaymentUploadFail = true;
                    }
                })
                .then(data => {
                    if(data?.message === 'failure'){
                        if(data?.invalidSellerIds?.length !== 0 && data?.invalidTransactions?.length !== 0){
                            this.apiErrorMessage = `Invalid seller IDs : ${data?.invalidSellerIds}, Invalid Transactions : ${data?.invalidTransactions}`
                        }else if(data?.invalidSellerIds?.length !== 0){
                            this.apiErrorMessage = `Invalid seller IDs : ${data?.invalidSellerIds}`
                        }else if(data?.invalidTransactions?.length !== 0){
                            this.apiErrorMessage = `Invalid Transactions : ${data?.invalidTransactions}`
                        }
                        this.isPaymentUploadFail = true;
                    }else if(data?.message === 'success'){
                        this.apiErrorMessage = null;
                        this.apiSuccessMessage = 'Payment Details successfully updated !';
                    }
                })
            }
        },
        onUploadPromotionalCreditBtnClick(event){
            this.apiErrorMessage = null;
            this.apiSuccessMessage = null;
            this.promotionalCreditFile = event.target.files[0]
        },
        onUploadCreditDetailsBtnClick(event){
            this.apiErrorMessage = null;
            this.apiSuccessMessage = null;
            this.creditDetailsFile = event.target.files[0]
            // const formData = new FormData();
            // formData.append('file', this.creditDetailsFile);
            // uploadCreditDetails(formData)
        },
        onUploadRechargeDetailsBtnClick(event){
            this.apiErrorMessage = null;
            this.apiSuccessMessage = null;
            this.rechargeDetailsFile = event.target.files[0];
            // const formData = new FormData();
            // formData.append('file', this.rechargeDetailsFile);
            // uploadRechargeDetails(formData)
        }
   }
}
</script>

<style scoped>

.sub-heading{
    padding: 6px 10px 6px 0px;
    margin: 24px 16px 0px 16px;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 19px;
    letter-spacing: 0.01em;
    color: #666666;
}
.btnWrap{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    border: 1px solid #cccccc;
    border-radius: 500px;
    padding: 2px 8px 2px 4px;
}
.errorContainer{
    background: #FDEDED;
    border-radius: 8px;
    margin: 2%;
    margin-bottom: unset;
    padding: 18px 24px;
    font-family: 'Inter-Regular';
    font-style: normal;
    margin: 12px 16px 8px 16px;
}

.successContainer{
    background-color: #DFF2BF;
}

.successHeading{
    color: #270 !important;
}

.errorHeading{
    font-weight: 700;
    font-size: 12px;
    line-height: 30%;
    color: #EB5757;
    /* margin-bottom: 12px; */
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
.buttons{
    padding: 14px 10px;
    background: #F8F8F8;
    border-radius: 4px;
    margin: 12px 16px 8px 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    max-width: 1240px;
}

label{
    margin-right: 10px;
    max-width: 162px;
}

.btn{
    cursor: pointer;
    opacity: 0.8;
    font-size: 14px;
    font-weight: 500;
    line-height: 23px;
    padding: 6px 12px;
    text-align: center;
    color: #0004B5;
    border-radius: 4px;
    width: fit-content;
    height: fit-content;
    margin-right: 24px;
    border: 1px solid #2E31BE;
    cursor: pointer;
}

.uploadBtn{
    cursor: pointer;
    background: #2E31BE;
    border-radius: 4px;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    width: 80px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
}
.billingContainer {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}
.title{
    margin-left:20px;
}
.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}
.paymentContainer {
    display: flex;
    flex-direction: column;
    margin: 1%;
    text-align: start;
    background: #FFFFFF;
    padding: 22px 24px 36px;
    border-radius: 12px;
}
.upload-section {
    margin: 16px 0;
    width: 100%;
    max-width: 600px;
}
.upload-container {
    border: 2px dashed #cccccc;
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    transition: border-color 0.3s ease;
    background-color: #fafafa;
    height:144px;
}
.upload-error-container {
    border: 2px dashed #cd9898;
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    transition: border-color 0.3s ease;
    background-color: #fdeded;
    height:144px;
}
.upload-container.drag-active {
    border-color: #2E31BE;
    background-color: #f0f0ff;
}

.upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.upload-icon {
    width: 40px;
    height: 40px;
}

.file-types {
    color: #666;
    font-size: 0.9em;
    margin-top: 4px;
    opacity: 0.8;
}

.file-input {
    display: none;
}

.button-section {
    display: flex;
    justify-content: center;
}
.upload-button {
    background: #2E31BE;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 4px;
    margin-top: 16px;
    margin-inline-start: 8px;
    cursor: pointer;
    transition: opacity 0.3s ease;
}

.upload-button:hover {
    opacity: 0.9;
}

.file-info {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
    padding: 4px 4px 4px 8px;
    background: #2e31be1a;
    border-radius: 4px;
    border: solid 1px #2e31be73;
    width: fit-content;
}

.file-error-info {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
    padding: 4px 4px 4px 8px;
    background: #be2e2e1a;
    border-radius: 4px;
    border: solid 1px #be2e2e73;
    width: fit-content;
}

.file-name {
    flex-grow: 1;
    font-size: 12px;
}

.file-size {
    color: #666;
    font-size: 0.9em;
}

.remove-btn {
    background: none;
    border: none;
    color: #EB5757;
    cursor: pointer;
    font-size: 1.2em;
    padding: 0 8px;
    font-weight: 800;
}

.click-text {
    color: #0004B5;
    font-weight: 700;
    cursor:pointer;
}

.download-icon {
    cursor: pointer;
    padding: 4px;
    border: 1px solid #666;
    border-radius: 50%;
}
.download-icon:hover {
    background-color: rgb(212, 239, 201);
}

</style>